import { Transfer } from "antd"
import { useEffect, useMemo, useState } from "react";
import { LoyaltyProgramDataProvider } from "../../../../../Services/DataProviders/LoyaltyProgramDataProvider";
import { useAppContext } from "../../../../../system/providers/appContextProvider";
import { ILoyaltyProgramDTO } from "../../../../../libs/coreapi-dto/dirs/loyaltyProgram";
import { Spinner } from "../../../../../components/spiner/Spinner";
import { ITransferProgramsLoyaltyProps, RecordType } from "../../interface";

const TransferProgramsLoyalty: React.FC<ITransferProgramsLoyaltyProps> = ({
    value = [],
    onChange,
    data,
    idGlobalPL
}) => {
    const appCtx = useAppContext()
    const LPDataProvider = new LoyaltyProgramDataProvider(appCtx.coreApiService);

    const [allProgramsData, setAllProgramsData] = useState<ILoyaltyProgramDTO[]>([]);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    const gridFilterPrograms: IGridFilter = {
        numberPerPage: 15,
        pageNumber: 1,
        columnFilters: [
            {
                name: "deleted",
                operator: "Eq",
                value: false,
            },
            {
                name: "idContractorGlobal",
                operator: "Eq",
                value: data?.idContractorGlobal,
            },
        ]
    };

    const transformDataToTransferFormat = (programs: ILoyaltyProgramDTO[]): RecordType[] => {
        return programs.map(program => ({
            key: program.idGlobal,
            title: program.name || program.displayName || 'Без названия',
        }));
    };

    const filteredTransferData = useMemo(() => {

        const allData = transformDataToTransferFormat(allProgramsData);

        return allData.filter(item =>
            !value.includes(item.key) &&
            item.key !== idGlobalPL);
    }, [allProgramsData, value, idGlobalPL]);

    const selectedProgramsInfo = useMemo(() => {
        return allProgramsData
            .filter(program =>
                value.includes(program.idGlobal) &&
                program.idGlobal !== idGlobalPL
            )
            .map(program => ({
                key: program.idGlobal,
                title: program.name || program.displayName || 'Без названия',
            }));
    }, [allProgramsData, value, idGlobalPL]);

    const transferDataSource = useMemo(() => {
        return [...filteredTransferData, ...selectedProgramsInfo];
    }, [filteredTransferData, selectedProgramsInfo]);

    useEffect(() => {
        setIsSubmitting(true)
        LPDataProvider.getView(gridFilterPrograms, (data, totalCount) => {
            if (totalCount > gridFilterPrograms.numberPerPage) {
                const allDataFilter = { ...gridFilterPrograms, numberPerPage: totalCount, pageNumber: 1 };
                LPDataProvider.getView(allDataFilter, (data) => {
                    setAllProgramsData(data);
                    setIsSubmitting(false);
                });
            } else {
                setAllProgramsData(data);
                setIsSubmitting(false);
            }
            setAllProgramsData(data);
            setIsSubmitting(false);
        })
    }, [])

    const filterOption = (inputValue: string, option: RecordType) =>
        option.title.toLowerCase().includes(inputValue.toLowerCase())

    const handleChange = (newTargetKeys: string[]) => {
        if (onChange) {
            onChange(newTargetKeys);
        }
    };

    if (isSubmitting) {
        return <Spinner />;
    }

    return (
        <div>
            <Transfer
                dataSource={transferDataSource}
                targetKeys={value}
                onChange={handleChange}
                render={item => `${item.title}`}
                showSearch
                filterOption={filterOption}
                listStyle={{
                    width: 900,
                    height: 500
                }}
                pagination
            />
        </div>
    )
}

export default TransferProgramsLoyalty